import { Account } from '../types/Account';

// Akahu accounts sync daily, so a balance older than this means the account
// has stopped updating and may have been closed.
const STALE_AFTER_MS = 24 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export const isRemoved = (account: Account): boolean => !!account.removedAt;

// Akahu account types, so manual accounts group the same way as synced ones.
// KIWISAVER matters: asset allocation treats it as an aggressive holding.
export const ACCOUNT_TYPES: Array<{ value: string; label: string }> = [
  { value: 'CHECKING', label: 'Everyday' },
  { value: 'SAVINGS', label: 'Savings' },
  { value: 'TERMDEPOSIT', label: 'Term deposit' },
  { value: 'INVESTMENT', label: 'Investment' },
  { value: 'KIWISAVER', label: 'KiwiSaver' },
  { value: 'CREDITCARD', label: 'Credit card' },
  { value: 'LOAN', label: 'Loan' },
  { value: 'FOREIGN', label: 'Foreign currency' },
  { value: 'WALLET', label: 'Wallet' },
];

// Manual balances are entered by hand, so they never count as stale.
export const isStale = (account: Account, now = Date.now()): boolean => {
  if (account.isManual) return false;
  const { recordDate } = account.balance;
  if (!recordDate) return true;
  return now - new Date(recordDate).getTime() > STALE_AFTER_MS;
};

export const formatLastUpdated = (
  recordDate: string | undefined,
  now = Date.now(),
): string => {
  if (!recordDate) return 'Never updated';
  const days = Math.floor((now - new Date(recordDate).getTime()) / DAY_MS);
  if (days < 1) return 'Updated today';
  return `Updated ${days} day${days === 1 ? '' : 's'} ago`;
};
